/**
 * 約款別パターンにより追加するrequest項目の定義
 */
export const StiPtnAddName = {
  // 契約電流
  conAmpA: 'conAmpA',
  // 契約容量
  conCapKva: 'conCapKva',
  // 契約電力
  conEleKw: 'conEleKw',
} as const;

